import { render, staticRenderFns } from "./AvatarInput.vue?vue&type=template&id=06718611&"
import script from "./AvatarInput.vue?vue&type=script&lang=js&"
export * from "./AvatarInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports